angular.module('unergie.main')
.factory('DataModelService', (DataAccess, AlertManager, ErrorCatcher) => {
    const models = {
        CLIENTS: null,
        PROSPECTS: null,
        CONTRACTS: null,
        B2G: null,
        B2BG_USERS: null,
    }

    const getDataModel = function (modelName) {
        if (!Object.keys(models).includes(modelName)) {
            return AlertManager.error(`Modèle inconnu '${modelName}'`)
        }
        if (models[modelName]) {
            return models[modelName]
        }
        models[modelName] = DataAccess.getDataModelDefinition({ modelName }).$promise
        .catch(ErrorCatcher)
        return models[modelName]
    }

    return {
        getDataModel,
    }
})
